import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import Carousel from 'nuka-carousel';
import cn from 'classnames';

import { onEvent } from 'helpers/EventHelpers';
import Dots from 'components/common/ImageCarouselDots.jsx';

import css from 'styles/components/common/imageCarousel.scss';

const ImageCarousel = createReactClass({
  getInitialState() {
    return {
      autoplay: this.props.autoplay,
      currentSlide: 0,
      isDragging: false
    };
  },

  componentDidMount() {
    onEvent(window, 'resize', () => {
      this.resizeCarousel();
    }, null, this);
    /*
     * This is a sanity check as Nuka can initially
     * be offset due to JS writing widths to the
     * container before the page is done rendering.
     */
    this.asyncResizeCarousel(1000);
  },

  componentDidUpdate() {
    const { currentSlide } = this.state;
    const { children, afterSlide } = this.props;
    const { carousel } = this.refs;

    if (children.length < currentSlide + 1) {
      carousel.goToSlide(0);
      afterSlide && afterSlide(0);
      this.setState({ currentSlide: 0 });
    }
  },

  onSlideChange(slideIndex) {
    const { afterSlide } = this.props;

    const { carousel } = this.refs;
    // Turn off autoplay on user interaction
    if (this.state.isDragging) {
      if (this.state.currentSlide !== slideIndex) {
        this.setState({ autoplay: false });
      }
      this.endTouch();
    }

    // Work around for https://github.com/kenwheeler/nuka-carousel/issues/129
    if (afterSlide && carousel?.props.slideIndex !== slideIndex) {
      afterSlide(slideIndex);
    }

    // Set new current slide
    this.setState({ currentSlide: slideIndex });
  },
  // Work around bug where carousel does not always resize when images are loaded
  resizeCarousel() {
    if (this.refs.carousel && this.refs.carousel.setDimensions) {
      this.refs.carousel.setDimensions();
    }
  },

  asyncResizeCarousel(time = 10) {
    setTimeout(this.resizeCarousel, time);
  },

  startTouch() {
    this.setState({ isDragging: true });
  },
  endTouch() {
    this.setState({ isDragging: false });
  },

  render() {
    const { showSliderDecorator, slidesToScroll, slidesToShow, children, wrapAround, slideIndex, overlapDots } = this.props;
    const { testId } = this.context;
    const { autoplay } = this.state;
    let renderDots = null;
    let testIdValue = null;

    if (showSliderDecorator) {
      renderDots = true;
      testIdValue = testId('imageCarouselSlideCounter');
    }
    return (
      <div
        className={cn(css.imageCarouselContainer, { [css.overlap]: overlapDots })}
        onLoad={this.asyncResizeCarousel}
        data-test-id={testId('imageCarousel')}
        onTouchStart={this.startTouch}>
        <Carousel
          autoGenerateStyleTag={false}
          renderCenterLeftControls={null}
          renderCenterRightControls={null}
          slidesToScroll={slidesToScroll}
          slidesToShow={slidesToShow}
          wrapAround={true}
          autoplay={autoplay}
          autoplayInterval={5000}
          pauseOnHover={true}
          dragging={true}
          swiping={true}
          afterSlide={this.onSlideChange}
          slideIndex={slideIndex}
          wrapAround={wrapAround}
          testId={testId}
          renderBottomCenterControls={props =>
            <Dots
              {...props}
              render={renderDots}
              testId={testIdValue}
              baseClass={css.imageCarouselSlideCounter}
              activeClass={css.active}
            />
          }
        >
          {children}
        </Carousel>
      </div>
    );
  }
});

ImageCarousel.propTypes = {
  afterSlide: PropTypes.func,
  slidesToShow: PropTypes.number.isRequired,
  slidesToScroll: PropTypes.number.isRequired,
  autoplay: PropTypes.bool.isRequired,
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  showSliderDecorator: PropTypes.bool,
  wrapAround: PropTypes.bool
};

ImageCarousel.defaultProps = {
  showSliderDecorator: true,
  wrapAround: true
};

ImageCarousel.contextTypes = {
  testId: PropTypes.func
};

export default ImageCarousel;
